import React, { useContext } from "react";
import Snackbar from "@mui/material/Snackbar";
import { theme } from "../styles/theme";
import { Box, Typography } from "@mui/material";
import { font } from "../styles/font";
import { IconCheck } from "../svgIcons/icons";
import { ApplicationContext } from "../context/application_ctx";

export const GlobalSnackBar = ({ open, title,close }) => {
  const {setGlobalSnackBar} = useContext(ApplicationContext)

const handleClose = ()=>{
  setGlobalSnackBar({open:false})
 close && close(false)
}
  return (
    <>
      <Snackbar
      autoHideDuration={3500}
      onClose={handleClose}
        open={open}
        sx={{
          ".MuiPaper-root": {
            border: "3px solid white",
            borderRadius: "8px",
            color: "black",
          },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Box
          display="flex"
          minWidth="380px"
          px={2}
          padding="7px"
          gap="12px"
          borderRadius="8px"
          boxShadow="0px 0px 2px grey"
          border="3px solid white"
          alignItems="center"
          backgroundColor={theme.col_5}
        >
          {title?.includes("successful") || title?.includes("successfully") ? (
            <IconCheck />
          ) : (
            <img
              width={30}
              height={30}
              src={require("../assets/images/lightbulb.png")}
              alt='warning'
            />
          )}
          <Typography
            fontFamily={font.family.fm_2}
            fontSize={font.size.fs_4}
            color={theme.col_6}
            sx={{ wordBreak: "break-all" }}
          >
            {title}
          </Typography>
        </Box>
      </Snackbar>
    </>
  );
};
